import { GOLD_PRICE_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export function PostGoldPrice(data){
  const api = `${GOLD_PRICE_API}ordinary/`;
  return axiosHttp.post(api, data);
}
